<div class="lvi-content">
	<div class="avatar">
		<!-- Drapeau pour pays/ville -->
		<span *ngIf="data.hasDrapeau()" class="flag-icon flag-icon-squared"
			  [ngClass]="'flag-icon-' + data.codeIso?.toLowerCase()"></span>
		<!-- Icône globe pour zone/territoire -->
		<mat-icon *ngIf="!data.hasDrapeau()">language</mat-icon>
	</div>
	<div class="lvi-body">
		<div class="title">
			<a class="label" (click)="consultFraisMission()">{{ data.getTitreComplet() }}</a>
		</div>
		<ul class="lvi-attrs">
			<li *ngIf="data.libellesDomaines">
				<strong [translate]="'admin.frais.indemnites.fraisMissions.liste.indemnites'"></strong>{{ data.libellesDomaines }}
			</li>
			<li *ngIf="data.getPeriodeData()">
				<strong [translate]="'admin.frais.indemnites.fraisMissions.liste.periode'"></strong>{{ data.getPeriodeData().key | translate: data.getPeriodeData().params }}
			</li>
			<li *ngIf="data.dateApplication">
				<strong [translate]="'admin.frais.indemnites.fraisMissions.liste.dateApplication'"></strong>{{ data.dateApplication }}
			</li>
			<li>
				<strong [translate]="'admin.frais.indemnites.fraisMissions.liste.type'"></strong>{{ 'admin.frais.indemnites.fraisMissions.liste.types.' + data.typeTerritoire | translate }}
			</li>
			<li *ngIf="data.hasTauxSpecial">
				<strong [translate]="'admin.frais.indemnites.fraisMissions.liste.tauxSpecial'"></strong>{{ 'global.oui' | translate }}
			</li>
		</ul>
	</div>
	<!-- Chevron pour déplier les autres périodes -->
	<div class="lvi-actions" *ngIf="data.isParent && data.enfants?.length">
		<button mat-icon-button (click)="data.toggleExpand()">
			<mat-icon>{{ data.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
		</button>
	</div>
</div>
<!-- Enfants (autres périodes) -->
<div *ngIf="data.isExpanded && data.enfants?.length" class="p-20" style="padding-top: 0;">
	<div *ngFor="let enfant of data.enfants" class="lvi-content" style="border-top: 1px solid #e0e0e0; padding-top: 10px; margin-top: 10px;">
		<div class="avatar">
            <span *ngIf="enfant.hasDrapeau()" class="flag-icon flag-icon-squared"
				  [ngClass]="'flag-icon-' + enfant.codeIso?.toLowerCase()"></span>
			<mat-icon *ngIf="!enfant.hasDrapeau()">language</mat-icon>
		</div>
		<div class="lvi-body">
			<div class="title">
				<a class="label" (click)="consultFraisMission(enfant)">{{ enfant.getTitreComplet() }}</a>
			</div>
			<ul class="lvi-attrs">
				<li *ngIf="enfant.libellesDomaines">
					<strong [translate]="'admin.frais.indemnites.fraisMissions.liste.indemnite'"></strong>{{ enfant.libellesDomaines }}
				</li>
				<li *ngIf="enfant.getPeriodeData()">
					<strong [translate]="'admin.frais.indemnites.fraisMissions.liste.periode'"></strong>{{ enfant.getPeriodeData().key | translate: enfant.getPeriodeData().params }}
				</li>
				<li *ngIf="enfant.dateApplication">
					<strong [translate]="'admin.frais.indemnites.fraisMissions.liste.dateApplication'"></strong>{{ enfant.dateApplication }}
				</li>
			</ul>
		</div>
	</div>
</div>